import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { resources, ns, supportedLngs, fallbackLng } from './resources';

let initialized = false;

const initI18n = () => {
  if (initialized) return i18n;

  i18n.use(detector).use(initReactI18next).init({
    supportedLngs,
    fallbackLng,
    fallbackNS: ns,
    ns,
    defaultNS: ns[0],
    resources,
  });

  initialized = true;

  return i18n;
};

export default initI18n;
